import { render, staticRenderFns } from "./SearchOrgList.vue?vue&type=template&id=e2e45e4e&scoped=true"
import script from "./SearchOrgList.vue?vue&type=script&lang=js"
export * from "./SearchOrgList.vue?vue&type=script&lang=js"
import style0 from "./SearchOrgList.vue?vue&type=style&index=0&id=e2e45e4e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e45e4e",
  null
  
)

export default component.exports